import type { UUID } from 'magpie-types';

export const getUUID = (): UUID => {
  const crypto = window.crypto || (window as any).msCrypto;

  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }

  // Use Crypto API if available
  if (
    typeof crypto !== undefined &&
    typeof crypto.getRandomValues === 'function'
  ) {
    return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
      // prettier-ignore
      // eslint-disable-next-line no-bitwise
      (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16)
    );
  }

  let uuid = '';
  let r;

  for (let i = 0; i < 32; i++) {
    // eslint-disable-next-line no-bitwise
    r = (Math.random() * 16) | 0;

    if (i === 8 || i === 12 || i === 16 || i === 20) {
      uuid += '-';
    }

    // eslint-disable-next-line no-bitwise
    uuid += (i === 12 ? 4 : i === 16 ? (r & 3) | 8 : r).toString(16);
  }
  return uuid;
};
